import { useEffect, useState } from 'react'

export const useViewPort = () => {
  const [viewport, setViewport] = useState('')

  useEffect(() => {
    const checkWindowSize = () => {
      window.innerWidth < 768 ? setViewport('mobile') : setViewport('desktop')
    }

    //First time after mount check window size
    checkWindowSize()

    window.addEventListener('resize', checkWindowSize)
    return () => {
      window.removeEventListener('resize', checkWindowSize)
    }
  }, [])

  return viewport
}
